import Modal from "../Modal"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import ConfigMainNewProject from "./ConfigMainNewProject"

interface ConfigModalProps {
  closeModal: () => void
  isOpen: boolean
  quadriConfigurationUiUrl: string
  submitQuadriProject: (e: any) => void
}

const ConfigModal = (props: ConfigModalProps) => {
  const { t } = useTranslation("config")
  const { closeModal, isOpen } = props

  const [featureCatalogStandard, setFeatureCatalogStandard] = React.useState<string | undefined>("")

  useEffect(() => {
    if (isOpen) {
      setFeatureCatalogStandard("")
    }
  }, [isOpen])

  return (
    <Modal
      closeModal={closeModal}
      heading={t("objectModelConfig.modalHeading")}
      submitButtonText={t("objectModelConfig.save")}
      submitButtonClasses="warning"
      fill={true}
    >
      <ConfigMainNewProject />
    </Modal>
  )
}

export default ConfigModal
